import _objectSpread from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _fadeStyles;

import * as React from 'react';
import { ENTERING, EXITING } from 'react-transition-group/Transition';
import Fade from './Fade';
import { jsx as _jsx } from "react/jsx-runtime";
var fadeStyles = (_fadeStyles = {}, _defineProperty(_fadeStyles, ENTERING, 'showing'), _defineProperty(_fadeStyles, EXITING, 'showing show'), _fadeStyles);
var ToastFade = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(Fade, _objectSpread({}, props, {
    ref: ref,
    transitionClasses: fadeStyles
  }));
});
ToastFade.displayName = 'ToastFade';
export default ToastFade;